import React, { useState } from 'react'
import i18n from 'live/services/i18n'
import { WidgetGallery } from '../../../../common/types/api/page'
import * as movementHelper from '../helper/GalleryContentMovementUtils'
import styled from 'styled-components'

interface Props {
    columns: WidgetGallery[][]
    onChangeColumns: (newColuns: WidgetGallery[][]) => void
    row: number
    col: number
    id: string
    editMode: boolean
}

export default function GalleryMovementDropdownIcon({ columns, onChangeColumns, row, col, id, editMode }: Props): JSX.Element {
    function checkDisabled(cheker, columns, row, col) {
        try {
            return !cheker(columns, row, col)
        } catch (e) {
            return true
        }
    }
    
    const disabledMoveUp = !editMode || checkDisabled(movementHelper.canMoveUp, columns, row, col)
    const disabledMoveLeft = !editMode || checkDisabled(movementHelper.canMoveLeft, columns, row, col)
    const disabledMoveRight = !editMode || checkDisabled(movementHelper.canMoveRight, columns, row, col)
    const disabledMoveDown = !editMode || checkDisabled(movementHelper.canMoveDown, columns, row, col)

    const disabledMoveNewLineUp = !editMode || checkDisabled(movementHelper.canMoveNewLineUp, columns, row, col)
    const disabledMoveNewLineDown = !editMode || checkDisabled(movementHelper.canMoveNewLineDown, columns, row, col)
    if(!columns || columns.length == 0 || row < 0 || col < 0){
        return null
    }
    const changeGallery = (checkIsValid, callback) => {
        try {
            if (editMode && checkIsValid(columns, row, col)) {
                onChangeColumns(callback(columns, row, col) as WidgetGallery[][])
            }
        } catch (e) {
            console.error(e, 'row: ', row, 'col: ', col)
        }
    }

    return (
        <GalleryMovementDropdownIconContainer id={id} key={id}>
            <DropdownContainerOption  className="--dropdownContainerOption"
                onClick={() => changeGallery(movementHelper.canMoveUp, movementHelper.moveUp)}
                disabled={disabledMoveUp}
                
            >
                <i className="fas fa-chevron-up" />
                <span>{i18n('Move up')}</span>
            </DropdownContainerOption>
            <DropdownContainerOption  className="--dropdownContainerOption"
                onClick={() => changeGallery(movementHelper.canMoveDown, movementHelper.moveDown)}
                disabled={disabledMoveDown}
            >
                <i className="fas fa-chevron-down"></i>
                <span>{i18n('Move down')}</span>
            </DropdownContainerOption>
            <DropdownContainerOption  className="--dropdownContainerOption"
                onClick={() => changeGallery(movementHelper.canMoveRight, movementHelper.moveRight)}
                disabled={disabledMoveRight}
            >
                <i className="fas fa-chevron-right"></i>
                <span>{i18n('Move right')}</span>
            </DropdownContainerOption>
            <DropdownContainerOption  className="--dropdownContainerOption"
                onClick={() => changeGallery(movementHelper.canMoveLeft, movementHelper.moveLeft)}
                disabled={disabledMoveLeft}
            >
                <i className="fas fa-chevron-left"></i>
                <span>{i18n('Move left')}</span>
            </DropdownContainerOption>
            <DropdownContainerOption  className="--dropdownContainerOption"
                onClick={() => changeGallery(movementHelper.canMoveNewLineUp, movementHelper.moveNewLineUp)}
                disabled={disabledMoveNewLineUp}
                style={{ borderTop: 'solid 1px rgb(200, 204, 212)' }}                
            >
                <i className="fas fa-plus"></i>
                <span>{i18n('Move in a new row above')}</span>
            </DropdownContainerOption>
            <DropdownContainerOption  className="--dropdownContainerOption" 
            onClick={() => changeGallery(movementHelper.canMoveNewLineDown, movementHelper.moveNewLineDown)}
            disabled={disabledMoveNewLineDown}>
                <i className="fas fa-plus"></i>
                <span>{i18n('Move in a new row below')}</span>
            </DropdownContainerOption>
        </GalleryMovementDropdownIconContainer>
    )
}

const GalleryMovementDropdownIconContainer = styled.div`
    min-height: auto;
    width: 100%;
    background: var(--palette-light-mode-gray-0, #fff);
    border: 1px solid rgb(200, 204, 212);
    border-radius: 4px;
`

const DropdownContainerOption = styled.div<{ disabled }>`
    display: flex;
    justify-content: flex-start;
    gap: 8px;
    width: 100%;
    height: 38px;
    padding: 12px 16px 8px 16px;
    font-family: ${({ theme }) => theme['font-regular']};
    color: var(--gray-500, #bac0cb);
    i {
        color: ${({ theme, disabled }) => (disabled ? theme['gray-500'] : theme['blue-500'])};
        text-align: center;
        font-size: 14px;
        font-family: Font Awesome 5 Pro;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 14px;
        height: 16px;
    }
    i,
    span {
        transition: all 0.2s;
        color: ${({ theme, disabled }) => (disabled ? 'var(--gray-500)' : 'var(--gray-800)')};
    }

    span {
        width: auto;
        height: 16px;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px;
    }

    :hover {
        background: var(--gray-100, #f5f5f5);
        i {
            ${({ theme, disabled }) => (!disabled ? 'color: ' + theme['blue-500'] : '')};
        }

        span {
            ${({ disabled }) => (!disabled ? 'font-weight: 600' : '')};
        }
    }
    &.--enabled {
    }
`
